import { createSlice } from "@reduxjs/toolkit";

const localAction = localStorage.getItem("uvita-action");
export const actionSlice = createSlice({
    name: "action",
    initialState: {
        actionData: (localAction && JSON.parse(localAction)) || {},
    },
    reducers: {
        setActionData: (state, action) => {
            state.actionData = action.payload;
            localStorage.setItem(
                "uvita-action",
                JSON.stringify(action.payload) || ""
            );
        },
    },
});
// 每个 case reducer 函数会生成对应的 Action creators
export const { setActionData } = actionSlice.actions;

export default actionSlice.reducer;
